// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Bookmark_sidebar__Kxo5L","contentContainer":"Bookmark_contentContainer__3p-4m","wrapper":"Bookmark_wrapper__1ClbU","container":"Bookmark_container__h06bP"};